import { render } from "./BarcodeInfoLabel.vue?vue&type=template&id=dcd45f60&scoped=true"
import script from "./BarcodeInfoLabel.vue?vue&type=script&lang=ts"
export * from "./BarcodeInfoLabel.vue?vue&type=script&lang=ts"

import "./BarcodeInfoLabel.vue?vue&type=style&index=0&id=dcd45f60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dcd45f60"

export default script